(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-xwf-gallery]').forEach((gallery) => {
      if (gallery.dataset.xwfGalleryReady === 'true') return;

      const viewport = gallery.querySelector('[data-xwf-gallery-viewport]');
      const slides = [...gallery.querySelectorAll('[data-xwf-gallery-slide]')];
      const controls = gallery.querySelector('[data-xwf-gallery-controls]');
      const previous = gallery.querySelector('[data-xwf-gallery-previous]');
      const next = gallery.querySelector('[data-xwf-gallery-next]');
      const count = gallery.querySelector('[data-xwf-gallery-count]');
      const status = gallery.querySelector('[data-xwf-gallery-status]');
      if (!viewport || slides.length < 2 || !controls || !previous || !next || !count || !status) return;

      gallery.dataset.xwfGalleryReady = 'true';
      controls.hidden = false;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let scrollFrame = 0;
      let resizeFrame = 0;

      const nearestIndex = () => {
        const viewportRect = viewport.getBoundingClientRect();
        const rtl = window.getComputedStyle(viewport).direction === 'rtl';
        const edge = rtl ? viewportRect.right : viewportRect.left;
        let closest = 0;
        let distance = Infinity;

        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const offset = Math.abs((rtl ? rect.right : rect.left) - edge);
          if (offset < distance) {
            closest = index;
            distance = offset;
          }
        });

        return closest;
      };

      const updateControls = () => {
        activeIndex = nearestIndex();
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
        count.textContent = `${activeIndex + 1} / ${slides.length}`;
        const label = status.dataset.xwfGalleryStatusLabel.replace('#', String(activeIndex + 1));
        if (status.textContent !== label) status.textContent = label;
        slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== activeIndex)));
      };

      const goTo = (index, instant = false) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        const viewportRect = viewport.getBoundingClientRect();
        const slideRect = slides[target].getBoundingClientRect();
        const rtl = window.getComputedStyle(viewport).direction === 'rtl';
        const offset = rtl ? slideRect.right - viewportRect.right : slideRect.left - viewportRect.left;
        viewport.scrollTo({
          left: viewport.scrollLeft + offset,
          behavior: instant || reducedMotion.matches ? 'instant' : 'smooth'
        });
      };

      previous.addEventListener('click', () => goTo(nearestIndex() - 1));
      next.addEventListener('click', () => goTo(nearestIndex() + 1));
      viewport.addEventListener('keydown', (event) => {
        const rtl = window.getComputedStyle(viewport).direction === 'rtl';
        let target;
        if (event.key === 'ArrowRight') target = nearestIndex() + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') target = nearestIndex() + (rtl ? 1 : -1);
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = slides.length - 1;
        else return;
        event.preventDefault();
        goTo(target);
      });
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });
      viewport.addEventListener('scrollend', updateControls);

      const resize = () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          goTo(activeIndex, true);
          updateControls();
        });
      };

      const observer = 'ResizeObserver' in window ? new ResizeObserver(resize) : null;
      if (observer) observer.observe(viewport);
      else window.addEventListener('resize', resize);

      const selectBlock = (event) => {
        const index = slides.findIndex((slide) => slide.dataset.xwfGalleryBlock === event.detail?.blockId);
        if (index !== -1) goTo(index, true);
      };
      const unload = (event) => {
        if (!event.target.contains(gallery)) return;
        observer?.disconnect();
        window.removeEventListener('resize', resize);
        window.cancelAnimationFrame(scrollFrame);
        window.cancelAnimationFrame(resizeFrame);
        document.removeEventListener('shopify:block:select', selectBlock);
        document.removeEventListener('shopify:section:unload', unload);
      };

      document.addEventListener('shopify:block:select', selectBlock);
      document.addEventListener('shopify:section:unload', unload);
      updateControls();
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
